import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface DiscountItem {
  id: number
  title: string
  code: string
  description: string | null
  rate: number
  volume_limit: number
  usage_count: number
  priority: number
  credit_type: string
  expiry_date: string | null
  status: string
  isUsed: boolean
  is_system: boolean
  createdAt: string
  last_used_at: string | null
}

export interface AllDiscountsResponse {
  data: DiscountItem[]
  meta: {
    message: string
    errors: string[]
  }
}

export function getAllDiscountsAction(): Promise<ApiResponse<AllDiscountsResponse>> {
  return api.get<ApiResponse<AllDiscountsResponse>>(`/discounts/all`)
}

export interface PrintDiscountResponse {
  pdf_path: string
}

export function printDiscountAction(): Promise<ApiResponse<PrintDiscountResponse>> {
  const url = `/exports/discounts`
  return api.get<ApiResponse<PrintDiscountResponse>>(url)
}
